export const getTrackingId = () => {
  const { host } = window.location;
  switch (host) {
    case 'pecdata.com':
    case 'app.veriforceone.com':
      return 'UA-98996257-7';
    case 'beta.pecdata.net':
    case 'app.beta-veriforceone.com':
      return 'UA-98996257-6';
    default:
      return 'UA-98996257-5';
  }
};
